/**
 * Recording Slice — Voice recording state
 *
 * Handles: startRecording, cancelRecording, isRecording
 */

import type { StateCreator } from "zustand";
import { useStreamingTTSStore } from "../streamingTTSStore";
import { useTTSStore } from "../ttsStore";
import type { ConversationState } from "../conversationTypes";

export interface RecordingSlice {
  isRecording: boolean;

  startRecording: () => void;
  cancelRecording: () => void;
}

export const createRecordingSlice: StateCreator<
  ConversationState,
  [],
  [],
  RecordingSlice
> = (set) => ({
  isRecording: false,

  /**
   * Start voice recording
   */
  startRecording: () => {
    // Stop all TTS playback to avoid mic picking up speaker audio
    useTTSStore.getState().stop();
    useStreamingTTSStore.getState().cancel();
    set({
      isRecording: true,
      error: null,
      errorInfo: null,
    });
  },

  /**
   * Cancel voice recording
   */
  cancelRecording: () => {
    set({
      isRecording: false,
      error: null,
      errorInfo: null,
    });
  },
});
